/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMailingCampaign = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h16v9h-2V4H4v16h2.889v2H2V2zm8 11h12v9H10v-9zm2 2.92V20h8v-4.08l-4 2.8-4-2.8zm2.172-.92L16 16.28 17.828 15h-3.656zM6 6v5h8V6H6zm2 3V8h4v1H8zm0 4v2H6v-2h2zm0 3H6v2h2v-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMailingCampaign as MailingCampaign };
